import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils/cn';

/**
 * Una etiqueta chica con el tono de lo que dice (mapa de diseño 226, §3): fondo
 * suave, texto y borde del tono. Reemplaza, en el módulo Estrategias, los `Badge`
 * sólidos (success, warning, info): lo sólido queda para los botones. «MANDA»
 * no es una etiqueta: es la marca de la explicación del precio.
 */
const TONOS = {
  ok: 'border-ok-borde bg-ok-suave text-ok',
  // La dirección de un cambio de precio que baja (spec 227): no es un error.
  baja: 'border-baja-borde bg-baja-suave text-baja',
  alerta: 'border-alerta-borde bg-alerta-suave text-alerta',
  bloqueo: 'border-bloqueo-borde bg-bloqueo-suave text-bloqueo',
  info: 'border-info-borde bg-info-suave text-info',
  neutro: 'border-border bg-muted text-muted-foreground',
  ia: 'border-transparent bg-ia-suave text-ia',
} as const;

export type TonoDeEtiqueta = keyof typeof TONOS;

export function Etiqueta({
  tono = 'neutro',
  className,
  ...props
}: HTMLAttributes<HTMLSpanElement> & { tono?: TonoDeEtiqueta }) {
  return (
    <span
      data-tono={tono}
      className={cn(
        'inline-flex items-center gap-1 whitespace-nowrap rounded-sm border px-1.5 py-0.5 text-xs font-semibold leading-none',
        TONOS[tono],
        className
      )}
      {...props}
    />
  );
}
